<div class="filter-container space-between">
  <!-- Below 1024px the row holds the selection actions instead (Filter and Show on map would not fit) -->
  <!-- hidden, not destroyed: FilterComponent holds the active filter chips -->
  <app-filter
    [class.selection-hidden]="selectedRows > 0 && bp.isCompact()"
    [filterOptions]="filterOptions"
    [projects]="projects"
    [types]="types"
    [geofences]="geofences"
    (updateData)="updateData.emit($event)"
  ></app-filter>
  <!--
  extra button section
  -->
  <div class="buttons-container">
    @if (!isProjectComponentlist) {
    <div>
      @if (selectedRows > 0 && !archived) {
      <button class="hover-button margin-right-xs filter" (click)="deselect()">
        <svg-icon [svgStyle]="{ 'width.px': 14 }" class="orange-color" src="/assets/icons/close.svg"> </svg-icon>
        {{ selectedRows }} selected
      </button>
      } @if (selectedRows > 0 && !archived) {
      <button id="btn-archive" class="hover-button margin-right-xs filter" (click)="onArchive()">
        <svg-icon [svgStyle]="{ 'width.px': 14 }" class="orange-color" src="/assets/icons/icon-16-archive.svg">
        </svg-icon>
        {{ "component.archive" | translate }}
      </button>
      } @if (selectedRows > 0 && !archived) {
      <button id="btn-project" class="hover-button margin-right-xs filter" (click)="onProjectClick()">
        <svg-icon [svgStyle]="{ 'width.px': 14 }" class="orange-color" src="assets/icons/icon-16-set-project.svg">
        </svg-icon>
        {{ "component.project" | translate }}
      </button>
      } @if (canSwapToMap && !(selectedRows > 0 && bp.isCompact())) {
      <button id="btn-swap-view" class="hover-button margin-right-xs filter" (click)="onShowMapClick()">
        <svg-icon
          [ngClass]="selectedRows > 0 ? 'orange-color ' : 'black'"
          [svgStyle]="{ 'width.px': 14 }"
          src="{{ showMap ? '/assets/icons/list_export.svg' : '/assets/icons/icon-16-globe.svg' }}"
        >
        </svg-icon>
        {{ (showMap ? "component.showOnList" : "component.showOnMap") | translate }}
      </button>
      }
    </div>
    }
    <div>
      @if (!archived && shouldExport && !bp.isPhone()) {
      <button id="btn-export" class="hover-button margin-right-xs filter" [matMenuTriggerFor]="exportMenu">
        <svg-icon
          [ngClass]="selectedRows > 0 ? 'orange-color ' : 'black'"
          [svgStyle]="{ 'width.px': 14 }"
          src="/assets/icons/export.svg"
        >
        </svg-icon>
        {{ "component.export" | translate }}
      </button>
      }

      <!-- submenu of export button-->
      <mat-menu #exportMenu="matMenu">
        <button mat-menu-item (click)="onExport(exportType.FE_LIST)">
          <svg-icon [svgStyle]="{ 'width.px': 14 }" src="/assets/icons/list_export.svg"></svg-icon>
          <span class="pl-xs"> List export </span>
        </button>
        @if (!isProjectComponentlist) {
        <button mat-menu-item [disabled]="selectedRows > 200" (click)="onExport(exportType.BE_DATA)">
          <svg-icon [svgStyle]="{ 'width.px': 14 }" src="/assets/icons/data_base.svg"></svg-icon>
          <span class="pl-xs"> Data export </span>
        </button>
        }
      </mat-menu>
    </div>
  </div>
</div>
